
import  {configureStore,ThunkAction,Action} from "@reduxjs/toolkit";
import appReducers from "./reducers";


const ReduxStore=configureStore({
    reducer:appReducers,
    //devTools: false   ## production
    
})


export type RootState = ReturnType<typeof ReduxStore.getState>


export type AppDispatch = typeof ReduxStore.dispatch

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
export default ReduxStore;